export default __webpack_public_path__ + "static/media/dis-like.7933cc04.svg";